/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';

import {LocaleNumberPipe} from '../../common/filters/locale-number.pipe';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-file-size',
  template: '{{ displayValue }}'
})
export class FileSizeOutputComponent implements OnChanges {
  @Input() size: number;
  displayValue = '';

  constructor(private localeNumberPipe: LocaleNumberPipe) {
  }

  ngOnChanges(): void {
    let denominator = 1024;
    let unit = 'kb';
    let digits = '1.0-0';

    if (this.size > 1000000) {
      denominator = 1048576;
      unit = 'MB';
      digits = '1.0-1';
    }

    const formatted = this.localeNumberPipe.transform(this.size / denominator, digits);
    this.displayValue = `${formatted}${unit}`;
  }
}
